export enum UserBalanceType {
    Points = 0,
    Gems = 1,
    Diamonds = 2
}


